import { useTranslation } from "react-i18next";
import { memo, SetStateAction, useCallback, useState } from "react";
import SearchInput from "@/components/SearchInput/SearchInput";

interface TitleComplementProps {
  onSearch: (searchValue: string) => void;
  handleQuickSearchClear: () => void;
  searchQuery: string;
}

const TitleComplement = memo(
  ({ onSearch, handleQuickSearchClear, searchQuery }: TitleComplementProps) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState(searchQuery);

    const handleSearchChange = useCallback(
      (event: { target: { value: SetStateAction<string> } }) => {
        setSearchValue(event.target.value);
      },
      []
    );

    const handleOnSearch = () => {
      onSearch(searchValue);
    }

    return (
      <div className="motif-row" >
          <SearchInput
            aria-label="Search"
            onChange={handleSearchChange}
            onClear={handleQuickSearchClear}
            placeholder={t("global.globalPlaceholder.quickSearchPlaceHolder")}
            onFocusShow={false}
            value={searchQuery}
            onEnter={handleOnSearch}
            withOutDebounce={true}
          />
      </div>
    );
  }
);

export default TitleComplement;
